export enum WatchType {
    movie,
    tvshow
}